const updateItems = [
  { date: '07-29', title: '《社内相亲》番外篇正式上线，女神漫画下拉式独家首发', type: '上新' },
  { date: '07-28', title: '《我独自升级》第179话更新，济州岛突袭篇高潮来袭', type: '更新' },
  { date: '07-27', title: '女神漫画下拉式日漫频道新增《间谍过家家》第二季全集', type: '上新' },
  { date: '07-26', title: '《女神降临》完整版全集整理完毕，下拉式阅读体验升级', type: '公告' },
  { date: '07-25', title: '韩漫《某天成为公主》全部章节已支持下拉式连续阅读', type: '更新' },
  { date: '07-24', title: '女神漫画网服务器扩容完成，下拉式加载速度提升40%', type: '公告' },
  { date: '07-23', title: '《浪漫满屋》经典韩漫下拉式版本高清重制上线', type: '上新' },
  { date: '07-22', title: '本周热门：恋爱韩漫《她的私生活》点击突破50万', type: '热门' },
  { date: '07-21', title: '女神漫画下拉式阅读模式获用户好评，日活再创新高', type: '公告' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">最新动态</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式平台实时快讯，不错过每一部好作品</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden sm:block"></div>
          <div className="space-y-0">
            {updateItems.map((item, i) => (
              <div key={i} className="flex gap-4 py-3 group cursor-pointer">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-0.5">
                  <div className={`w-[10px] h-[10px] rounded-full border-2 z-10 ${
                    item.type === '上新' ? 'bg-primary-500 border-primary-200' :
                    item.type === '热门' ? 'bg-accent-500 border-accent-200' :
                    'bg-secondary-400 border-secondary-200'
                  }`}></div>
                </div>
                <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                  <span className="text-xs text-foreground-400 font-mono whitespace-nowrap flex-shrink-0">{item.date}</span>
                  <span className={`text-xs px-1.5 py-0.5 rounded font-medium whitespace-nowrap flex-shrink-0 inline-block w-fit ${
                    item.type === '上新' ? 'bg-primary-100 text-primary-600' :
                    item.type === '热门' ? 'bg-accent-100 text-accent-700' :
                    item.type === '公告' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-background-200 text-foreground-600'
                  }`}>{item.type}</span>
                  <p className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}